var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "section" },
    [
      _vm.dynamicFields[_vm.editIndex]
        ? _c(
            "b-modal",
            {
              attrs: { width: 640, scroll: "keep" },
              model: {
                value: _vm.isModalActive,
                callback: function ($$v) {
                  _vm.isModalActive = $$v
                },
                expression: "isModalActive",
              },
            },
            [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-content" },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "Name" } },
                      [
                        _c("b-input", {
                          model: {
                            value: _vm.dynamicFields[_vm.editIndex].name,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dynamicFields[_vm.editIndex],
                                "name",
                                $$v
                              )
                            },
                            expression: "dynamicFields[editIndex].name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "Display name" } },
                      [
                        _c("b-input", {
                          model: {
                            value: _vm.dynamicFields[_vm.editIndex].displayName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dynamicFields[_vm.editIndex],
                                "displayName",
                                $$v
                              )
                            },
                            expression: "dynamicFields[editIndex].displayName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "Translate ref" } },
                      [
                        _c("b-input", {
                          model: {
                            value:
                              _vm.dynamicFields[_vm.editIndex].translateRef,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.dynamicFields[_vm.editIndex],
                                "translateRef",
                                $$v
                              )
                            },
                            expression: "dynamicFields[editIndex].translateRef",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "Type" } },
                      [
                        _c(
                          "b-select",
                          {
                            model: {
                              value: _vm.dynamicFields[_vm.editIndex].type,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dynamicFields[_vm.editIndex],
                                  "type",
                                  $$v
                                )
                              },
                              expression: "dynamicFields[editIndex].type",
                            },
                          },
                          _vm._l(_vm.types, function (el, i) {
                            return _c(
                              "option",
                              { key: i, domProps: { value: el } },
                              [_vm._v(" " + _vm._s(el) + " ")]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm.dynamicFields[_vm.editIndex].type === "select"
                      ? _c(
                          "div",
                          [
                            _c("div", { staticClass: "columns" }, [
                              _c(
                                "div",
                                { staticClass: "column" },
                                [
                                  _c("b-field", {
                                    attrs: { label: "All Values" },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "column",
                                  staticStyle: { "text-align": "end" },
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { type: "is-primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.dynamicFields[
                                            _vm.editIndex
                                          ].selectFields.push({
                                            fieldId:
                                              _vm.dynamicFields[_vm.editIndex]
                                                .fieldId,
                                          })
                                        },
                                      },
                                    },
                                    [_vm._v(" Add ")]
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._l(
                              _vm.dynamicFields[_vm.editIndex].selectFields,
                              function (el, i) {
                                return _c(
                                  "div",
                                  { key: i, staticClass: "columns" },
                                  [
                                    _c("b-input", {
                                      staticClass: "column",
                                      model: {
                                        value:
                                          _vm.dynamicFields[_vm.editIndex]
                                            .selectFields[i].label,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dynamicFields[_vm.editIndex]
                                              .selectFields[i],
                                            "label",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dynamicFields[editIndex].selectFields[i].label",
                                      },
                                    }),
                                    _c("b-input", {
                                      staticClass: "column",
                                      model: {
                                        value:
                                          _vm.dynamicFields[_vm.editIndex]
                                            .selectFields[i].value,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dynamicFields[_vm.editIndex]
                                              .selectFields[i],
                                            "value",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dynamicFields[editIndex].selectFields[i].value",
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "column",
                                        staticStyle: { "text-align": "end" },
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            attrs: { type: "is-danger" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.dynamicFields[
                                                  _vm.editIndex
                                                ].selectFields.splice(i, 1)
                                              },
                                            },
                                          },
                                          [_vm._v(" RM ")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c("Header", _vm._b({}, "Header", _vm.$route.meta, false)),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _vm._v(" " + _vm._s(_vm.customerId) + " "),
            ]),
            _c(
              "div",
              { staticClass: "column", staticStyle: { "text-align": "end" } },
              [
                _c("b-button", { on: { click: _vm.newDynamicFields } }, [
                  _vm._v(" Add "),
                ]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c(
                  "b-table",
                  { attrs: { data: _vm.dynamicFields } },
                  [
                    _c("b-table-column", {
                      attrs: { label: "Name" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [_vm._v(" " + _vm._s(props.row.name) + " ")]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: { label: "Type" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [_vm._v(" " + _vm._s(props.row.type) + " ")]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: { label: "Display name" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.displayName) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: { label: "Translate ref" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(
                                " " + _vm._s(props.row.translateRef) + " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: { label: "Active" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.active) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("b-table-column", {
                      attrs: { label: "Action" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticClass: "buttons" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.edit(props)
                                        },
                                      },
                                    },
                                    [_vm._v(" Edit ")]
                                  ),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: props.row.active
                                          ? "is-danger"
                                          : null,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleActive(props)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            props.row.active
                                              ? "Desactivate"
                                              : "Activate"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { staticClass: "column", staticStyle: { "text-align": "end" } },
            [
              _c(
                "b-button",
                { attrs: { type: "is-primary" }, on: { click: _vm.pushData } },
                [_vm._v(" Save ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }